export const refreshLogoutTimer = () => {
  localStorage.setItem("logoutModalStart", String(Date.now()));
  window.dispatchEvent(
    new StorageEvent("storage", { key: "logoutModalStart" }),
  ); // Dispatch a storage event manually with a custom key
};
